import OrgChartNodeDeleteConfirmation from './OrgChartNodeDeleteConfirmation';

export default OrgChartNodeDeleteConfirmation;
